import { HTTP } from "../../../services/api-service.js";
import commonObj from "../../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = "";

const functionSecurityStore = {
  namespaced: true,
  state: {
    totalItem: 0,
    q: {
      tableNeedQuery: tableName,
      isOuterJoin: false,
      searchCriteria: "",
      orderBy: "",
      take: 1000000,
      skip: 0
    },
    currentSelectedPage: 0
  },
  actions: {
    getAllUserGroupRights({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        state.q.tableNeedQuery = "UserGrpRights";
        HTTP.post(baseUrl + "/qgl/listvalue", state.q)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    getAllSysMenu({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        state.q.tableNeedQuery = "SysMenu";
        HTTP.post(baseUrl + "/qgl/listvalue", state.q)
          .then(async (response) => {
            // Interacting with the store, see `localForage` API.
            // const length = await cache.store.length()
            // console.log('Cache store length:', length)
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    saveUserGrpRight({ commit }, param) {
      return new Promise((resolve, reject) => {
        tableName = "UserGrpRights";
        HTTP.post(
          baseUrl + "/mm/save",
          JSON.stringify({
            type: tableName,
            modelList: param.userGrpRightModel,
            option: param.option
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    exportFile({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/mm/export", state.q, { responseType: "blob" })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
export default functionSecurityStore;
